<mat-tab-group (selectedTabChange)="onTabChange($event)" #tabGroup class="edi-tabs-wrapper" mat-stretch-tabs="false"
  mat-align-tabs="start" [selectedIndex]="0">
  <mat-tab label="ePAL Commission" style="width: 25%;">
    <div id="epalcommission-main-wraper">
      <div class="col-12 search-ft p-0 mt-3">
        <div class="row">
          <div class="col">
            <div class="form-group">
              <label name="lblePALSrchBldId" class="control-label">Building Id</label>
              <input type="text" class="form-control" name="txtePALSrchBldId" [(ngModel)]="txtePALSrchBldId"
                maxlength="20" tabindex="1" (keydown.enter)="onKeyEnter()" />
            </div>
          </div>
          <div class="col">
            <div class="form-group">
              <label name="lblePALSrchBldName" class="control-label">Building Name</label>
              <input type="text" class="form-control" name="txtePALSrchBldName" [(ngModel)]="txtePALSrchBldName"
                maxlength="30" tabindex="2" (keydown.enter)="onKeyEnter()" />
            </div>
          </div>
          <div class="col">
            <div class="form-group">
              <label name="lblePALSrchBldAdd" class="control-label">Building Address</label>
              <input type="text" class="form-control" name="txtePALSrchBldAdd" [(ngModel)]="txtePALSrchBldAdd"
                maxlength="30" tabindex="3" (keydown.enter)="onKeyEnter()" />
            </div>
          </div>
          <div class="col">
            <div class="form-group">
              <label name="lblePALSrchUnitNum" class="control-label">Unit Number</label>
              <input type="text" class="form-control" name="txtePALSrchUnitNum" [(ngModel)]="txtePALSrchUnitNum"
                maxlength="30" tabindex="4" (keydown.enter)="onKeyEnter()" />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12 d-inline-flex p-0">
            <div class="col d-flex align-items-start">
              <div class="form-group">
                <button class="btn btn-primary mr-2" name="btnCOMSearch" (click)="getGridDataByFilterSearch()"
                  tabindex="5">
                  Search
                </button>
                <button class="btn btn-outline-primary mr-2" name="btnCOMReset" (click)="resetFilters($event)"
                  tabindex="6">
                  Reset
                </button>
              </div>
            </div>
            <div id="gridActions" class="ml-auto">
              <label *ngIf="isRowSelected" class="mr-2" name="lblEnaCom" (click)="open(ePalCommModal)"><span> <em
                    class="fas fa-tablet-alt"></em></span>&nbsp;ePAL Commission</label>
              <label *ngIf="!isRowSelected" class="mr-2" name="lblDisCom"
                title="Select the Building to Commission ePAL HardwareId"><span>
                  <em class="fas fa-tablet-alt"></em></span>&nbsp;ePAL Commission</label>
            </div>
            <div id="gridActions" class="ml-auto">
              <label class="mr-2" name="lblEnaDecom" (click)="open(DecommModal)"
                title="Click here to Decommission ePAL HardwareId"><span class="fa-stack"><em
                    class="fas fa-tablet-alt fa-stack-2x"></em><em
                    class="fas fa-slash fa-stack-1x"></em></span>&nbsp;ePAL Decommission</label>
            </div>
            <div id="gridActions" class="ml-auto">
              <label *ngIf="isRowSelected" class="mr-2" name="lblEnaEpalCom" (click)="open(ePalGatewayModal)"><span> <em
                    class="fas fa-wifi"></em></span>&nbsp;ePAL Gateway</label>
              <label *ngIf="!isRowSelected" class="mr-2" name="lblDisEpalCom"
                title="Select the Building to Commission ePAL Gateway"><span> <em
                    class="fas fa-wifi"></em></span>&nbsp;ePAL
                Gateway</label>
            </div>
          </div>
        </div>
      </div>

      <div>
        <ag-grid-angular #agGridCommission [enableCellTextSelection]="true"
          class="ag-theme-material mt-2 epalcommission-layout" [rowData]="rowData" [columnDefs]="columnDefs"
          [gridOptions]="gridOptions" (rowSelected)="onRowSelected($event)">
        </ag-grid-angular>
      </div>

<div id="epalcommissionmodel">
  <!-- ePALHardwareId Commission Modal Popup HTML -->
  <ng-template #ePalCommModal let-modal>    
    <div class="modal-header">
      <h5 class="modal-title" id="modal-basic-title">ePAL Commission</h5>
      <button type="button" class="close" aria-label="Close" (click)="modalClose('Cross click')">
        <em class="fas fa-times-circle"></em>
      </button>
    </div>
    <div class="modal-body">
      <div class="col-12 search-ft p-0 mt-3">
        <div class="row">
          <div class="col-3">
            <div class="form-group">
              <label class="control-label l-block">Production BuildingId</label>
              <input for="lblMdlePALSrchBldId" name="lblMdlePALSrchBldId" class="form-control" tabindex="7" [(ngModel)]="lblMdlBldId"
                readonly />
            </div>
          </div>
          <div class="col-3">
            <div class="form-group">
              <label class="control-label l-block">Building Name</label>
              <input for="lblMdlePALSrchBldName" name="lblMdlePALSrchBldName" class="form-control" tabindex="8"
                [(ngModel)]="lblMdlBldName" readonly />
            </div>
          </div>
          <div class="col-3">
            <div class="form-group">
              <label name="lblMdlePALHwIdSrc" class="control-label l-block required">ePAL
                UUID</label>
              <input type="text" class="form-control" tabindex="9" [(ngModel)]="txtMLePALHardwareId" maxlength="32" />
            </div>
            <div class="lblerror" *ngIf="lblComErrorePALHardwareId">
              {{ this.lblComErrorePALHardwareId }}
            </div>
          </div>
          <div class="col-3">
            <div class="form-group">
              <label class="control-label l-block required">Test Building Id</label>
              <input id="lblMdlePALTestBldId" type="text" class="form-control" name="lblMdlePALTestBldId"
                [(ngModel)]="txtMdlePALTestBldId" maxlength="32" tabindex="10"/>
            </div>
            <div class="lblerror" *ngIf="lblComErrorTestBldId">
              {{ this.lblComErrorTestBldId }}
            </div>
          </div>
        </div>
        <div class="row"> 
          <div class="col-3">
            <div class="form-group">
              <label name="lblEnvironment" class="control-label required">ePAL Device Environment</label>
              <select name="ddEnvironment" class="form-control" tabindex="11" (change)="onEnvironmentSelectChanged($event)" [(ngModel)]="selEloVersionNumber" [disabled]="isEnvironmentDisabled">
                <option value="3" selected>Current EloView 3.0(Default)</option>
                <option value="4">EloView 4.0</option>
              </select>
            </div>
          </div>
          <div class="col-3">
            <div class="form-group">
              <label name="lblMdlEloViewSerNum" class="control-label l-block required">EloView
                Serial Number</label>
              <input type="text" class="form-control" [(ngModel)]="txtMLEloviewSerialNum" maxlength="20" tabindex="12" (blur)="onEpalDeviceSearch()"/>
            </div>
            <div class="lblerror" *ngIf="lblMLEloviewSerialNum">
              {{ this.lblMLEloviewSerialNum }}
            </div>
          </div>
          <div class="col-3">
            <div class="form-group">
              <label name="lblAppContent" class="control-label required">Device Application
                Type</label>
              <select name="ddAppContent" class="form-control" tabindex="13" (change)="onContentSelectChanged($event)">
                <option value="0" selected>--- Select ---</option>
                <option *ngFor="let content of appContent" [selected]="content.contentId === appContentSelectedId"
                  [value]="content.contentId">
                  {{ content.applicationName }}
                </option>
              </select>
            </div>
            <div class="lblerror" *ngIf="appContentError">
              {{ this.appContentError }}
            </div>
          </div>
          <div class="col-3">
            <div class="form-group">
              <label name="lblEloViewDevice" class="control-label required">EloView
                Device</label>
              <input disabled type="text" class="form-control" [(ngModel)]="txtEloViewDevice" maxlength="20" tabindex="14" [title]="txtEloViewDevice"/>
              <label name="lblEloViewDeviceID" hidden>{{eloViewDeviceID}}</label>              
            </div>
            <div class="lblerror" *ngIf="eloViewDeviceError">
              {{ this.eloViewDeviceError }}
            </div>
          </div>
        </div> 
        <div class="row">
          <div class="col-3">
            <div class="form-group">
              <label name="lblGWMlIccId" class="control-label">SIM Card ICCID1 : AT&amp;T</label>
              <input type="text" class="form-control" name="txtGWMlIccId" [(ngModel)]="txtGWMlIccId" maxlength="30"
                (focus)="clearErrorMessages()" />
            </div>
          </div>
          <div class="col-3">
            <div class="form-group">
              <label name="lblGWMlIccId2" class="control-label">SIM Card ICCID2 : Verizon</label>
              <input type="text" class="form-control" name="txtGWMlIccId2" [(ngModel)]="txtGWMlIccId2" maxlength="20"
                (focus)="clearErrorMessages()" />
            </div>
            <div class="lblerror" *ngIf="lblICCID2error">
              {{ this.lblICCID2error }}
            </div>
            <div class="lblsuccess" *ngIf="lblICCID2success">
              {{ this.lblICCID2success }}
            </div>
          </div>
          <div class="col-3 lblAlign" *ngIf="txtEloViewDevice">
            <br/>
              <label name="lblEloViewDevice" class="control-label">Device Status</label>&nbsp;
                <i class="fa fa-circle cGreen" *ngIf="eloviewDeviceStatus"></i>
                <i class="fa fa-circle cRed" *ngIf="!eloviewDeviceStatus"></i>  
          </div>
        </div>        
        <div class="row">
          <div class="col">
            <div class="form-group">
              <label name="lblMdlUnitNum" class="control-label">Elevator Unit Number(s)</label>
              <div>
                <table aria-label="table" class="table-ml">
                  <thead>
                    <th id="unitNum">Unit Number</th>
                    <th id="contract">Contract</th>
                    <th id="stops">Stops</th>
                    <th id="city">City</th>
                  </thead>
                  <tr *ngFor="let unitNum of unitNumbers">
                    <td>{{ unitNum.elevatorUnitNumber }}</td>
                    <td>{{ unitNum.contract }}</td>
                    <td>{{ unitNum.stops }}</td>
                    <td>{{ unitNum.city }}</td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <div class="form-group">
              <label name="lblCommissionedDevices" class="control-label">ePAL Commissioned Devices</label>
              <div>
                <table aria-label="table" class="table-ml">
                  <thead>
                    <th id="epalUuid">ePAL UUID</th>
                    <th id="serialNumber">Serial Number</th>
                    <th id="deviceEnvironment">Device Environment</th>
                    <th id="deviceAppType">Device Application Type</th>
                    <th id="endTest">End Test</th>
                  </thead>
                  <ng-container *ngFor="let device of ePALCommissionedDevices; let i = index">
                    <tr>
                      <td>{{ device.ePALUUID }}</td>
                      <td>{{ device.serialNumber }}</td>
                      <td>{{ device.deviceEnvironment }}</td>
                      <td>{{ device.deviceApplicationType }}</td>
                      <td>
                        <div>{{ device.endTest ? "Completed" : "Not Completed" }}</div>
                        <a
                          *ngIf="hasCommissionedDeviceSimInfo(device)"
                          href="javascript:void(0);"
                          class="commissioned-device-link"
                          (click)="toggleCommissionedDeviceSimInfo(i)">
                          {{ expandedCommissionedDeviceIndex === i ? "Hide SIM Info" : "View SIM Info" }}
                        </a>
                      </td>
                    </tr>
                    <tr *ngIf="expandedCommissionedDeviceIndex === i" class="commissioned-device-detail-row">
                      <td colspan="5">
                        <div class="commissioned-device-details">
                          <div class="commissioned-device-detail-grid">
                            <div class="commissioned-device-detail-item" *ngIf="getCommissionedDeviceSim1(device)">
                              <span class="commissioned-device-detail-label">SIM Card ICCID1: AT&T</span>
                              <span class="commissioned-device-detail-value">{{ getCommissionedDeviceSim1(device) }}</span>
                            </div>
                            <div class="commissioned-device-detail-item" *ngIf="getCommissionedDeviceSim2(device)">
                              </div>
                          </div>
                          <div class="commissioned-device-detail-grid" *ngIf="getCommissionedDeviceSim2(device)">
                            <div class="commissioned-device-detail-item">
                              <span class="commissioned-device-detail-label">SIM Card ICCID2: Verizon</span>
                              <span class="commissioned-device-detail-value">{{ getCommissionedDeviceSim2(device) }}</span>
                            </div>
                            <div>
                              <span class="commissioned-device-detail-label commissioned-device-detail-label-status">Verizon SIM Status:</span>
                              <span class="commissioned-device-detail-value">{{ getCommissionedDeviceVerizonStatus(device) }}</span>
                            </div>
                          </div>
                        </div>
                      </td>
                    </tr>
                  </ng-container>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer d-flex flex-wrap align-items-center">
      <span style="font-size: small;" class="mr-auto">
        <i class="fa fa-circle cGreen"></i> : Online |
        <i class="fa fa-circle cRed"></i> : Offline
      </span>
      
      <button [disabled]="!isBtnStartEpal" type="button" class="btn btn-primary mr-1"
        (click)="onEpalCommForTestBld(true)" tabindex="15">
        Start ePAL Test
      </button>
      <button type="button" class="btn btn-primary mr-1" (click)="onInstallApkToDevice()" tabindex="16">
        Install Content To Device
      </button>
      <button type="button" class="btn btn-primary mr-1" (click)="onDeviceReboot()" tabindex="17">
        Reboot Device
      </button>      
      <button [disabled]="!isBtnEndEpal" type="button" class="btn btn-primary mr-1"
        (click)="onEPALCommAndDeComm()" tabindex="18">
        End ePAL Test
      </button>
      <button type="button" class="btn btn-primary mr-1" (click)="resetCommModal()" tabindex="19">
        Reset
      </button>
      <button type="button" class="btn btn-outline-primary" (click)="modalClose('Cross click')" tabindex="20">
        Close
      </button>
    </div>      
    <label class="mr-2" id="lblUpdDevice" name="lblPRProcess" (click)="open(UpdateEloViewDevice)" tabindex="4" [hidden]="true"><span>
      <em class="fa fa-angle-double-right"></em></span>
    Open</label>
  </ng-template>
</div>

<!-- ePALHardwareId Decommission Modal Popup HTML -->
<ng-template #DecommModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title" id="modal-basic-title">ePAL Decommission</h5>
    <button type="button" class="close" aria-label="Close" (click)="modalClose('Cross click')">
      <em class="fas fa-times-circle"></em>
    </button>
  </div>
  <div class="modal-body">
    <div class="col-12">
      <div class="row">
        <div class="col-4">
          <div class="form-group">
            <label name="lblDMLePALHwId" class="control-label">ePAL HardwareId :</label>
          </div>
        </div>
        <div class="col-4">
          <div class="form-group">
            <input id="txtDMLePALHWId" type="search" class="form-control" name="txtDMLePALHWId"
              [(ngModel)]="txtEpalHardwareId" (keydown.enter)="getBuildingUnitsSearch()" maxlength="32" tabindex="1" />
          </div>
          <div class="lblerror" *ngIf="lblDeComErrorePALHardwareId">
            {{ this.lblDeComErrorePALHardwareId }}
          </div>
        </div>
        <div class="col-2">
          <div class="form-group">
            <button class="btn btn-primary" name="btnDMLePALHWIDSearch" (click)="getBuildingUnitsSearch()" tabindex="2">
              Search
            </button>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <label name="lblMdlUnitNum" class="control-label"> <strong><u> Building And Unit
                Details</u></strong></label>
        </div>
      </div>
      <div class="row">
        <div class="col-3">
          <div class="form-group">
            <label name="lblePALSrchBldId" class="control-label">Building Id : </label>
            <label name="lblePALSrchBldId" class="control-label">{{ePALBuildingDetails.buildingId}}</label>
          </div>
        </div>
        <div class="col-4">
          <div class="form-group">
            <label name="lblePALSrchBldId" class="control-label">Building Name : </label>
            <label name="lblePALSrchBldId" class="control-label">{{ePALBuildingDetails.buildingName}}</label>
          </div>
        </div>
        <div class="col-5">
          <div class="form-group">
            <label name="lblePALSrchBldId" class="control-label">Eloview Serial Number : </label>
            <label name="lblePALSrchBldId" class="control-label">{{ePALBuildingDetails.eloviewSerialNumber}}</label>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-3">
          <div class="form-group">
            <label name="lblePALSrchBldId" class="control-label">SIMCardICCID1(AT&T) :</label>
            <label name="lblePALSrchBldId" class="control-label">{{ePALBuildingDetails.simCardICCID1}}</label>
          </div>
        </div>
        <div class="col-4">
          <div class="form-group">
            <label name="lblePALSrchBldId" class="control-label">SIMCardICCID2(Verizon) :</label>
            <label name="lblePALSrchBldId" class="control-label">{{ePALBuildingDetails.simCardICCID2}}</label>
          </div>
        </div>
        <div class="col-5">

              </div>
            </div>
            <div class="row">
              <div class="col">
                <div class="form-group">
                  <div>
                    <table aria-label="table" class="table-ml">
                      <thead>
                        <th id="unitNumber">Unit Number</th>
                        <th id="cpiduuid">CP-ID/UUID</th>
                        <th id="iotComm">Iot Commissioned</th>
                      </thead>
                      <tr *ngFor="let unitNum of ePALBuildingDetails.Units">
                        <td>{{ unitNum.unitNumber }}</td>
                        <td>{{ unitNum.cpidUuid }}</td>
                        <td>{{ unitNum.isIotCommissioned }}</td>
                      </tr>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" name="btnDecommission" class="btn btn-primary mr-2"
            (click)="onDecommissionePALHardwareId()">
            Decommission
          </button>
          <button type="button" name="btnDMLClose" class="btn btn-outline-primary mr-2"
            (click)="modalClose('Save click')">
            Close
          </button>
        </div>
      </ng-template>

      <!-- ePAL Gateway Commission Modal Popup HTML -->
      <ng-template #ePalGatewayModal let-modal>
        <div class="modal-header">
          <h5 class="modal-title" id="modal-basic-title">ePAL Gateway</h5>
          <button type="button" class="close" aria-label="Close" (click)="modalClose('Cross click')">
            <em class="fas fa-times-circle"></em>
          </button>
        </div>
        <div class="modal-body">
          <div class="col-12 search-ft p-0 mt-3">
            <div class="row">
              <div class="col">
                <div class="form-group">
                  <label name="lblGWDeviceMLType" class="control-label required">Device Gateway Type
                  </label>
                  <select name="ddGWDeviceMLType" [(ngModel)]="devicegatewayTypeSelId" class="form-control">
                    <option *ngFor="let type of Devicegateway" [value]="type.id"
                      [selected]="type.id === devicegatewayTypeSelId"
                      [selected]="type.value === gatewayTypeSelectedValue">
                      {{ type.name }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="col">
                <div class="form-group">
                  <label name="lblGWMLType" class="control-label required">Gateway Type
                  </label>
                  <select name="ddEGWMLType" class="form-control" (change)="gatewayTypeSelectChanged($event)">
                    <option *ngFor="let type of gatewayTypes" [value]="type.id"
                      [selected]="type.id === gatewayTypeSelectedId">
                      {{ type.name }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="col">
                <div class="form-group">
                  <label name="lblGWMlMacAdd" class="control-label required">Gateway Mac Address</label>
                  <input type="text" class="form-control" [disabled]="gatewayUpdateEnabled" name="txtGWMlMacAdd"
                    [(ngModel)]="txtGWMlMacAdd" maxlength="20" />
                </div>
                <div class="lblerror" *ngIf="lblErrorGWMLMacAdd">
                  {{ this.lblErrorGWMLMacAdd }}
                </div>
              </div>
              <div class="col">
                <label name="lblGWPwd" class="control-label">Gateway Password </label>
                <input type="password" class="form-control" name="txtGWPwd" [(ngModel)]="txtGWPwd" maxlength="20"
                  (focus)="clearErrorMessages()" />
              </div>

            </div>
            <div class="col-12 p-0">
              <div class="row">
                <div class="col">
                  <div class="form-group">
                    <label name="lblGWMlIccId" class="control-label">SIM Card ICCID1 : AT&T</label>
                    <input type="text" class="form-control" name="txtGWMlIccId" [(ngModel)]="txtGWMlIccId"
                      maxlength="20" (blur)="onATTDeviceSearch()"
                      [disabled]="gatewayUpdateEnabled && txtGWMlIccId.length === 20" />
                  </div>
                  <div class="lblerror" *ngIf="lblICCID1error">
                    {{ this.lblICCID1error }}
                  </div>
                  <div class="lblsuccess" *ngIf="lblICCID1success">
                    {{ this.lblICCID1success }}
                  </div>
                </div>
                <div class="col">
                  <div class="form-group">
                    <label name="lblGWMlIccId2" class="control-label">SIM Card ICCID2 : Verizon</label>
                    <input type="text" class="form-control" name="txtGWMlIccId2" [(ngModel)]="txtGWMlIccId2"
                      maxlength="20" (blur)="onVerizonDeviceSearch()"
                      [disabled]="gatewayUpdateEnabled && txtGWMlIccId2.length === 20" />
                  </div>
                  <div class="lblerror" *ngIf="lblICCID2error">
                    {{ this.lblICCID2error }}
                  </div>
                  <div class="lblsuccess" *ngIf="lblICCID2success">
                    {{ this.lblICCID2success }}
                  </div>
                </div>
                <div class="col">
                  <div class="form-group">
                    <label name="lblGWMlMacAdd" class="control-label">Otis ONE Compatible Firmware</label>
                    <select name="ddOOCVersion" class="form-control" (change)="fmOOCVersionSelectChanged($event)">
                      <option *ngFor="let type of txtECfwVersion.split(',')">
                        {{type}}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="col">
                  <div class="form-group">
                    <label name="lblSuggestedVersion" class="control-label">DRM Running Firmware</label>
                    <input type="text" disabled="true" class="form-control" name="txtECSuggestedVersion"
                      [(ngModel)]="txtECSuggestedVersion" maxlength="15" />
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="form-group" *ngIf="lblVersionMessage" [ngClass]="isVersionMatch ? 'greenlabel' : 'redlabel'">
                <label name="lblmessage">{{ lblVersionMessage }}</label>
              </div>
            </div>
            <div class="row">
              <div class="form-group" *ngIf="lblATTStatus" [ngClass]="isATTActivation ? 'greenlabel' : 'redlabel'">
                <label name="lblATTMessage">{{ lblATTStatus }}</label>
              </div>
            </div>
            <div class="row">
              <div class="form-group" *ngIf="lblVerizonStatus"
                [ngClass]="isVerizonActivation ? 'greenlabel' : 'redlabel'">
                <label name="lblmessage">{{ lblVerizonStatus }}</label>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <div class="form-group">
                  <label name="lblMdlUnitNum" class="control-label">Elevator Unit Number(s)</label>
                  <div>
                    <table aria-label="table" class="table-ml">
                      <thead>
                        <th id="unitNum">Unit Number</th>
                        <th id="contract">Contract</th>
                        <th id="stops">Stops</th>
                        <th id="city">City</th>
                      </thead>
                      <tr *ngFor="let unitNum of unitNumbers">
                        <td>{{ unitNum.elevatorUnitNumber }}</td>
                        <td>{{ unitNum.contract }}</td>
                        <td>{{ unitNum.stops }}</td>
                        <td>{{ unitNum.city }}</td>
                      </tr>
                    </table>
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col">
                <div class="form-group">
                  <label name="lblMdlEpalGateway" class="control-label">ePAL Gateway(s)</label>
                  <div>
                    <table aria-label="table" class="table-ml">
                      <thead>
                        <th id="buildingId">Building Id</th>
                        <th id="buildingName">Building Name</th>
                        <th id="deviceGatewayType">Device Gateway Type</th>
                        <th id="gatewayType">Gateway Type</th>
                        <th id="ePALMacAddress">ePAL Gateway MacAddress</th>
                        <th id="ePALGatewayDelink">Action</th>
                      </thead>
                      <tr *ngFor="let gatewayInfo of ePALCommissionedGateways">
                        <td>{{ gatewayInfo.buildingId }}</td>
                        <td>{{ gatewayInfo.buildingName }}</td>
                        <td>{{ gatewayInfo.deviceGatewayType }}</td>
                        <td>{{ gatewayInfo.gatewayType }}</td>
                        <td>{{ gatewayInfo.gatewayMacAddress }}</td>
                        <td> <a href="javascript:void(0);" (click)="onEpalDecommission(gatewayInfo)">Decommission</a>
                        </td>
                      </tr>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <!-- Buttons -->
          <button type="button" class="btn btn-primary mr-2" (click)="AssignEpalGateway($event)">
            Assign ePAL Gateway
          </button>
          <button type="button" class="btn btn-primary mr-2" (click)="onUpdateFirmware($event)"
            [disabled]="!gatewayUpdateEnabled">
            Get Firmware Version
          </button>
          <button type="button" class="btn btn-primary mr-2" (click)="onReset($event)">
            Reset
          </button>
          <button type="button" class="btn btn-outline-primary mr-2" (click)="modalClose('Cross click')">
            Close
          </button>
        </div>
      </ng-template>

      <ng-template #UpdateEloViewDevice let-modal>
        <div id="updateDevice" class="modal-body eloUpdateStyle">
          <div class="col-12 search-ft p-2 mt-3">
            <div class="row">
              <div class="col">
                <div class="form-group">
                  <label class="lblInfo"> ePAL Device Already Exists in EloView as:</label>
                  <br>
                  <label class="lblDevInfo">{{ temptxtEloViewDevice }}</label>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <div class="form-group">
                  <label class="lblInfo">Would you like to update the device info to:</label>
                  <br>
                  <label class="lblDevInfo">{{ lblNewDeviceName }}</label>
                </div>
              </div>
            </div>
            <div class="row col-6 mx-auto d-flex justify-content-center">
              <button type="button" class="btn btn-primary mr-2 btnwidth"
                (click)="onEpalCommForTestBld(false)">Yes</button>
              <button type="button" id="btnClose" class="btn btn-outline-primary mr-2 btnwidth"
                (click)="modal.close('Save click')">No</button>
            </div>
          </div>
        </div>
      </ng-template>
    </div>
  </mat-tab>
  <mat-tab label={{eloViewSync}} [disabled]="!enableEloViewSync" style="width: 25%;">
    <app-eloview-sync></app-eloview-sync>
  </mat-tab>
  <mat-tab [disabled]=true></mat-tab>
  <mat-tab [disabled]=true></mat-tab>
</mat-tab-group>